import React, { useEffect, useState } from 'react';
import './whatsapp.css';
import { trackWhatsappClick } from '../../services/analytics';

const WhatsAppButton = () => {
    const [showTooltip, setShowTooltip] = useState(true);
  
    useEffect(() => {
      const timer = setTimeout(() => setShowTooltip(false), 3000); // hide after 3s
      return () => clearTimeout(timer);
    }, []);
  
    const handleMouseEnter = () => setShowTooltip(true);
    const handleMouseLeave = () => setShowTooltip(false);

    const handleWhatsAppClick = (e) => {
      // Track the click
      trackWhatsappClick('floating_button');
    };

    const phoneNumber = "8807341866"; // Replace with your WhatsApp number

    return (
      <div 
        className="whatsapp-container" 
        onMouseEnter={handleMouseEnter} 
        onMouseLeave={handleMouseLeave}
      >
        {showTooltip && <div className="tooltip">Chat with us!</div>}
        <a
          href={`https://wa.me/${phoneNumber}`}
          className="whatsapp-button"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleWhatsAppClick}
        >
          <img
            src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
            alt="Chat on WhatsApp"
          />
        </a>
      </div>
    );
  };
  
  export default WhatsAppButton;